module.exports = __webpack_public_path__ + "img/coming-soon-PC.18c5cd11.jpg";